import * as L from 'leaflet';

const map = (lat, lng, zoom = 10, options = { zoomControl: false, scrollWheelZoom: false }) => ({
  mapElement: null,
  initilized: false,

  init() {
    this.initilize();
  },

  initilize() {
    if (this.initilized) {
      return;
    }

    this.mapElement = L.map(this.$refs.map, options).setView([lat, lng], zoom);
    this.initTileLayer();
    this.initMarker();
    this.initilized = true;

    this.afterInit?.();
  },

  initTileLayer() {
    L.tileLayer('https://tiles.bergfex.at/styles/bergfex-osm/{z}/{x}/{y}@2x.jpg', {
      attribution: 'bergfex gmbh',
    }).addTo(this.mapElement);
  },

  initMarker() {
    L.marker([lat, lng], { icon: this.getMarkerIcon() }).addTo(this.mapElement);
  },

  getMarkerIcon() {
    return L.icon({
      iconUrl: '/images/presentation/map/marker/default@2x.png',
      iconSize: [32, 32],
      iconAnchor: [16, 32],
    });
  },
});

export default map;
